export default {
  data () {
    return {
      tableFilter: ''
    }
  },
  computed: {
    filteredData () {
      return this.getDataToFilter().filter(data => {
        const searchFor = this.tableFilter.toLowerCase()
        const dataProperty = data.name.toLowerCase().indexOf(searchFor)
        return dataProperty >= 0
      })
    }
  }
}
